module.exports = __webpack_public_path__ + "img/m_7.d65f05d3.png";